module.exports = __webpack_public_path__ + "img/20190724.c59c6e55.jpg";